import { render, staticRenderFns } from "./AirwayDicomPanel.vue?vue&type=template&id=3e70f7f3&scoped=true&"
import script from "./AirwayDicomPanel.vue?vue&type=script&lang=js&"
export * from "./AirwayDicomPanel.vue?vue&type=script&lang=js&"
import style0 from "./AirwayDicomPanel.vue?vue&type=style&index=0&id=3e70f7f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e70f7f3",
  null
  
)

export default component.exports